module.exports = __webpack_public_path__ + "img/tiktok.c4fbfdf6.svg";